import styled from "styled-components";
import React from "react";
import {Flex} from "../components/StyleComponents";
import {inject, observer} from "mobx-react";
import Widget from "../stores/Widget";
import {observable} from "mobx";

const CampaignTemplateWrapperStyled = styled(Flex)``;

@inject('campaignStore')
@observer
class CampaignTemplateWrapper extends React.Component<any, any> {

    @observable isSaveButtonDisable = true;

    onWidgetEditHandler = (widgetIndex: number) => {
        this.props.campaignStore.setWidgetSelected(widgetIndex);
    };

    onWidgetDeleteHandler = (widgetIndex: number) => {
        this.props.campaignStore.campaign.template.deleteWidget(widgetIndex);
    };

    onWidgetAddHandler = (widget: Widget, index: number) => {
        this.props.campaignStore.campaign.template.addWidget(widget.config.type, index);
    };

    resetWidgetSelected = () => {
        this.props.campaignStore.setWidgetSelected(null);
    };

    save = async () => {
        this.isSaveButtonDisable = true;
        return await this.props.campaignStore.save();
    };

    updateData = (key: string, value: any) => {
        this.isSaveButtonDisable = false;
        if (this.props.campaignStore.campaign.selectedWidget) {
            this.props.campaignStore.campaign.selectedWidget.data[key] = value;
        }
    };

    updateHtml = (html: string) => {
        this.props.campaignStore.campaign.setHtml(html);
    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        const childrenWithProps = React.Children.map(this.props.children, (child: any) => {
            return React.cloneElement(child, {
                props: this.props,
                isSaveButtonDisable: this.isSaveButtonDisable,
                widgetEditHandler: this.onWidgetEditHandler,
                widgetDeleteHandler: this.onWidgetDeleteHandler,
                widgetAddHandler: this.onWidgetAddHandler,
                resetWidgetSelected: this.resetWidgetSelected,
                save: this.save,
                updateData: this.updateData,
                widget: this.props.campaignStore.campaign.selectedWidget,
                widgets: this.props.campaignStore.campaign.template.widgets,
                isOpen: this.props.campaignStore.isWidgetSelected,
                updateHtml: this.updateHtml
            })
        });

        return (
            <CampaignTemplateWrapperStyled {...this.props}>
                {childrenWithProps}
            </CampaignTemplateWrapperStyled>
        );
    }
}

export default CampaignTemplateWrapper;

